import React from 'react';
import { type Loan, formatAmount } from '../data/loans';
interface LoanCardProps {
  loan: Loan;
}
export function LoanCard({
  loan
}: LoanCardProps) {
  return <article className="flex h-full flex-col rounded-3xl bg-white p-7 ring-1 ring-ink/10" data-id="element-68" data-mp="bt33lm6mqpdx">
      <h3 className="text-base font-bold uppercase tracking-wide text-ink" data-id="element-69" data-mp="6tqib5vepqdg">
        {loan.name}
      </h3>

      <div className="mt-4 flex flex-wrap items-center gap-2" data-id="element-70" data-mp="2sepkrh8kp11">
        <span className="inline-flex h-7 items-center rounded-full bg-ink/5 px-3 text-xs font-bold text-ink" data-id="element-71" data-mp="zj73bigp64zn">
          {loan.rating}
        </span>
        <span className="inline-flex h-7 items-center rounded-full bg-forest px-3 text-xs font-bold text-white" data-id="element-72" data-mp="qjsjh1v1cso4">
          Risiko: {loan.risk}
        </span>
        <span className="inline-flex h-7 items-center rounded-full border border-ink/15 px-3 text-xs font-bold text-muted" data-id="element-73" data-mp="lk7kirfv8kbe">
          {loan.country}
        </span>
      </div>

      <p className="mt-6 font-mono text-xs text-muted" data-id="element-74" data-mp="369wtwoxsvdwp">{loan.isin}</p>
      <p className="mt-1 text-2xl font-bold tracking-tight text-ink" data-id="element-75" data-mp="pf4dwhssicth">
        {loan.currency} {formatAmount(loan.amount)}
      </p>

      <p className="mt-4 text-sm leading-relaxed text-muted" data-id="element-76" data-mp="uco1477gtzxk">
        {loan.description}
      </p>

      <div className="mt-auto pt-8" data-id="element-77" data-mp="gdekj6fcl3t2">
        <div className="flex items-baseline gap-3" data-id="element-78" data-mp="ggiwwr2yv5ut">
          <span className="text-4xl font-extrabold tracking-tight text-ink" data-id="element-79" data-mp="lc81j8tufcxz">
            {loan.rate}
          </span>
          <span className="text-sm text-muted" data-id="element-80" data-mp="6mtqlwamcngh">{loan.termMonths} måneder</span>
        </div>

        <div className="mt-5" data-id="element-81" data-mp="bfv7g9udyx2p">
          <div className="flex items-baseline justify-between text-sm" data-id="element-82" data-mp="bgxxkfjvwvhk">
            <span className="text-muted" data-id="element-83" data-mp="3tunp7m75l1wq">Tilgængeligt</span>
            <span className="font-semibold tabular-nums text-ink" data-id="element-84" data-mp="1os8bdl0os62">
              {loan.currency} {formatAmount(loan.available)}
            </span>
          </div>
          <div className="mt-2 h-2 w-full overflow-hidden rounded-full bg-ink/10" role="progressbar" aria-valuenow={loan.fundedPct} aria-valuemin={0} aria-valuemax={100} aria-label={`${loan.name} er ${loan.fundedPct}% finansieret`} data-id="element-85" data-mp="3jwzp0gqs3276">
            <div className="h-full rounded-full bg-brand" style={{
            width: `${loan.fundedPct}%`
          }} data-id="element-86" data-mp="1llh7mdmp5iet" />
          </div>
          <p className="mt-2 text-sm text-muted" data-id="element-87" data-mp="1gnxrf86fuvk8">
            {loan.fundedPct}% finansieret
          </p>
        </div>

        <a href="https://portal.flexfunding.com/signup?partner=almenr" className="mt-6 inline-flex w-full items-center justify-center rounded-full bg-brand px-6 py-3.5 text-base font-bold text-white transition-colors duration-150 ease-smooth hover:bg-brand-dark focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand" data-id="element-88" data-mp="2daj7cm3q8z8k">
          Investér nu
        </a>
      </div>
    </article>;
}